import { __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import ReactGA from 'react-ga4';
import { getCurrentEnvironment, getHostName } from '../apiEndpoint/apiEndpoint.js';
import { addExtraInfo } from './segments.js';

var trackingEnabled = function () {
    var environment = getCurrentEnvironment(getHostName());
    return environment === 'production' || environment === 'test';
};
var trackEvent = function (options) {
    if (!trackingEnabled()) {
        return {
            success: false,
            message: 'tracking disabled',
        };
    }
    if (!(options instanceof Object)) {
        return {
            success: false,
            message: 'options not an object',
        };
    }
    var mandatoryAttributes = ['eventCategory', 'eventAction'];
    var missingAttributes = mandatoryAttributes.filter(function (attribute) { return !(attribute in options); });
    if (missingAttributes.length > 0) {
        return {
            success: false,
            message: "".concat(missingAttributes.join(', '), " missing"),
        };
    }
    var googleOptions = _assign(_assign({}, options), addExtraInfo());
    var eventName = options.eventName || "".concat(options.eventCategory, "_").concat(options.eventAction);
    ReactGA.event(eventName, googleOptions);
    return {
        success: true,
        message: 'success',
        data: googleOptions,
    };
};

export { trackEvent, trackingEnabled };
